/**
 * HeyCatch analytics — se inicializa SOLO tras aceptar las cookies de análisis.
 *
 * Misma puerta que PostHog (`public/analytics.js`): la clave de localStorage
 * `tino_cookie_consent` vale 'granted' o 'denied'. Si el usuario rechaza, o aún
 * no ha respondido, no se inicializa nada.
 *
 * Solo pageviews, clics y UTM automáticos. Sin `setIdentity` ni datos personales.
 * Lo cargan las páginas que llevan el banner de cookies (index.html, fisioterapia.html).
 */
import { analytics } from '@heycatch/sdk';

const CONSENT_KEY = 'tino_cookie_consent';
let started = false;

function startHeyCatch(): void {
  if (started) return;
  started = true;
  analytics.init({
    projectKey: 'hck_pk_QEDYt5xgr_Vhr4CekGPOQtGitRelhYqV',
    requestBatching: false, // varias páginas con carga completa, sin router en cliente
    install: { framework: 'vite-react', agent: 'claude-code' },
  });
}

let stored: string | null = null;
try {
  stored = localStorage.getItem(CONSENT_KEY);
} catch {
  stored = null;
}

if (stored === 'granted') startHeyCatch();

document.getElementById('tino-cc-accept')?.addEventListener('click', startHeyCatch);
